<template>
  <svg
    version="1.1"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :heigth="size"
  >
    <path d="M0,0h24v24h-24Z" fill="none" />
    <path
      fill="currentColor"
      d="M6.41421,10.5858c0.781049,0.781049 0.781049,2.04738 0,2.82843c-0.781049,0.781049 -2.04738,0.781049 -2.82843,0c-0.781049,-0.781049 -0.781049,-2.04738 -4.44089e-16,-2.82843c0.781049,-0.781049 2.04738,-0.781049 2.82843,0"
    />
    <g fill="currentColor">
      <path
        d="M13.4142,10.5858c0.781049,0.781049 0.781049,2.04738 0,2.82843c-0.781049,0.781049 -2.04738,0.781049 -2.82843,0c-0.781049,-0.781049 -0.781049,-2.04738 0,-2.82843c0.781049,-0.781049 2.04738,-0.781049 2.82843,0"
      />
      <path
        d="M20.4142,10.5858c0.781049,0.781049 0.781049,2.04738 0,2.82843c-0.781049,0.781049 -2.04738,0.781049 -2.82843,0c-0.781049,-0.781049 -0.781049,-2.04738 0,-2.82843c0.781049,-0.781049 2.04738,-0.781049 2.82843,0"
      />
    </g>
  </svg>
</template>

<script>
'use strict'

import mixinIcon from '../mixinIcon'

export default {
  name: 'imageIcon',
  mixins: [mixinIcon]
}
</script>
